import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExpand315: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconExpand315"><Path fillRule="evenodd" clipRule="evenodd" d="M11 3H3V11H4.5V5.56066L10.25 11.3107L11.3107 10.25L5.56066 4.5H11V3ZM12.6893 13.75L18.4393 19.5H13V21H21V13H19.5V18.4393L13.75 12.6893L12.6893 13.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconExpand315;
